// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"125d15bb","787":"46d15545","850":"44ccc70d"}[chunkId] + ".chunk.js";
};